module.exports = __webpack_public_path__ + "static/media/majors-students-clubs.90b2264d.jpg";